import React, { useState, memo } from 'react';
import styled from 'styled-components';
import Button from './Button';
import PasswordInput from './PasswordInput';
import { useProfileStore } from '../store/profileStore';
import { useApiCall } from '../hooks/useApiCall';

const FormRow = styled.div`
  display: flex;
  justify-content: stretch;
  gap: 48px;
  width: 100%;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const FormField = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 32px;
  
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 24px;
    
    button {
      width: 100%;
    }
  }
`;

const ErrorText = styled.div`
  color: #D85355;
  font-size: 14px;
  margin-top: 16px;
`;

const SecurityForm: React.FC = () => {
  const { isUpdatingPassword, updatePassword } = useProfileStore();
  const { executeApiCall } = useApiCall();

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setValidationError(null);

    if (newPassword !== confirmPassword) {
      setValidationError('Пароли не совпадают');
      return;
    }

    if (newPassword.length < 8) {
      setValidationError('Новый пароль должен содержать минимум 8 символов');
      return;
    }

        const result = await executeApiCall(
      () => updatePassword(oldPassword, newPassword),
      {
        successMessage: 'Пароль успешно изменен. Вы остаетесь авторизованы.',
        errorMessage: 'Ошибка смены пароля'
      }
    );
    
    if (result !== null) {
      // Очищаем форму только при успешной смене
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <FormRow>
        <FormField>
          <PasswordInput
            label="Старый пароль"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            placeholder="Введите старый пароль"
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <PasswordInput
            label="Новый пароль"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Введите новый пароль"
          />
        </FormField>

        <FormField>
          <PasswordInput
            label="Подтвердите пароль"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Введите пароль повторно"
            error={validationError && newPassword !== confirmPassword ? 'Пароли не совпадают' : undefined}
          />
        </FormField>
      </FormRow>

      {validationError && <ErrorText>{validationError}</ErrorText>}

      <ButtonContainer>
        <Button type="submit" disabled={isUpdatingPassword}>
          {isUpdatingPassword ? 'Сохранение...' : 'Сохранить изменения'}
        </Button>
      </ButtonContainer>
    </form>
  );
};

export default memo(SecurityForm);